import { EncryptStorage } from 'encrypt-storage';

// Example of secret_key variable in an .env file
// const encryptStorage = new EncryptStorage(process.env.SECRET_KEY, options);
export const encryptStorage = new EncryptStorage('fgc-storage');

export function descryptValue(item){
    return encryptStorage.getItem(item, false)
} 

export function encryptValue(key,item){
    return encryptStorage.setItem(key, item, true)
}